export default __webpack_public_path__ + "static/CLUB-6-9694d2c7c57fa25e5e6a7f8630f66b7e.png";